import styled from 'styled-components';

export default styled.div`
	display: flex;
	justify-content: end;
	.motif-dropdown {
		.motif-dropdown-item {
			height: auto;
		}
		.motif-dropdown-menu {
			.customScrollbar {
				all: unset !important;
			}
		}
	}
`;
